import { motion } from "framer-motion";
import { MaskedLines } from "./motion";

export const PageHero = ({ kicker, lines, intro, image, alt, children }) => (
  <section className="relative overflow-hidden bg-ink pb-20 pt-36 text-white md:pb-28 md:pt-44" data-testid="page-hero">
    <div className="grain" aria-hidden="true" />
    <div className="glow-orb absolute -right-32 -top-20 h-[460px] w-[460px] opacity-50" aria-hidden="true" />
    <div className={`relative mx-auto grid max-w-[1400px] items-end gap-14 px-5 md:px-10 ${image ? "lg:grid-cols-12" : ""}`}>
      <div className={image ? "lg:col-span-7" : "max-w-5xl"}>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} className="font-mono text-xs uppercase tracking-[0.25em] text-glint">{kicker}</motion.p>
        <h1 className="mt-8 font-display text-[13vw] font-semibold leading-[0.92] tracking-[-0.035em] sm:text-7xl lg:text-8xl" data-testid="page-heading">
          <MaskedLines lines={lines} />
        </h1>
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.9 }}>
          {intro && <p className="mt-10 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg">{intro}</p>}
          {children}
        </motion.div>
      </div>
      {image && (
        <motion.div
          initial={{ clipPath: "inset(12% 12% 12% 12% round 28px)", opacity: 0 }}
          animate={{ clipPath: "inset(0% 0% 0% 0% round 28px)", opacity: 1 }}
          transition={{ duration: 1.4, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="relative h-[360px] overflow-hidden md:h-[480px] lg:col-span-5"
        >
          <img src={image} alt={alt} className="h-full w-full object-cover" />
          <div className="sweep absolute inset-0" aria-hidden="true" />
        </motion.div>
      )}
    </div>
  </section>
);
